import mori from 'mori';

/**
 * Get active locations or false for all
 * @param  {mori.vector} locations [locations from combinedFilters[0]]
 * @return {mori.vector || false}  [active locations]
 */
export default function getLocations(locations) {
  return mori.count(locations) > 0 ?
    mori.map((item) => mori.first(mori.vals(item)), mori.flatten(locations)) :
    false;
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getFootnotes/getLocations.js